<template>
  <q-dialog
    v-model="shown"
    persistent
  >
    <q-card
      data-test-id="select-site-dialog-card"
    >
      <q-inner-loading
        style="z-index: 1;"
        :showing="loading"
      />
      <q-card-section
        v-if="currentUser"
        class="column items-center"
      >
        <q-select
          v-model="currentUser.circuitId"
          data-test-id="circuit-select"
          class="set-site-dialog-select q-mr-md q-my-sm full-width"
          label="Circuit"
          bg-color="white"
          :options="currentUser.authorizedCircuitOptions"
          option-label="name"
          option-value="id"
          map-options
          emit-value
          :disable="loading"
          @update:model-value="handleCircuitChange()"
        />
        <q-select
          v-if="!userCircuitMigratedUrl"
          v-model="siteId"
          data-test-id="site-select"
          class="set-site-dialog-select q-mr-md q-my-sm full-width"
          label="Site"
          bg-color="white"
          :options="currentUser.authorizedSiteOptions"
          option-label="name"
          option-value="id"
          map-options
          emit-value
          :disable="loading"
          :readonly="!currentUser.authorizedSiteOptions.length"
          @update:model-value="handleSiteChange()"
        >
          <q-tooltip v-if="!currentUser.authorizedSiteOptions.length">
            No sites available for this circuit.
          </q-tooltip>
        </q-select>
        <slot
          v-if="!userCircuitMigratedUrl"
          :loading="loading"
        />
        <div
          v-else
          class="col-auto text-h6"
        >
          This site has been migrated to <a :href="userCircuitMigratedUrl">our new Beta region</a>.
        </div>
      </q-card-section>

      <q-card-actions
        align="right"
      >
        <q-btn
          v-if="!userCircuitMigratedUrl"
          data-test-id="set-site-dialog-quit-button"
          label="Quit"
          color="primary"
          flat
          @click="quit"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'SetSiteDialog',
  context: ['currentUser'],
  props: {
    modelValue: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value', 'site-changed', 'quit', 'loading'],
  data () {
    return {
      shown: false,
      siteId: null,
      loading: false
    }
  },
  computed: {
    userCircuitMigratedUrl () {
      return this.currentUser?.circuitMigratedUrl
    }
  },
  watch: {
    modelValue: {
      handler () {
        this.shown = this.modelValue
      },
      immediate: true
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    },
    loading () {
      this.$emit('loading', this.loading)
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    hide () {
      this.shown = false
    },
    quit () {
      this.$emit('quit')
    },
    async handleSiteChange () {
      try {
        this.loading = true
        this.currentUser.siteId = this.siteId
        await this.$changeCircuitOrSite()
        await this.$handleAuthChange()
        this.$emit('site-changed', this.siteId)
      } catch (exception) {
        this.$rollbar.error(`Failed to handleSiteChange(), exception: ${exception.message}`)
      } finally {
        this.loading = false
      }
    },
    async handleCircuitChange () {
      try {
        this.loading = true
        await this.$changeCircuitOrSite()
        await this.$handleAuthChange()
      } catch (exception) {
        this.$rollbar.error(`Failed to handleCircuitChange(), exception: ${exception.message}`)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.set-site-dialog-select {
  min-width: 200px;
}
</style>
